import "./App.css";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import Home from "./pages/Home";
import Demo from "./pages/Demo";
import Freetrail from "./pages/Freetrail";
import BlogsPage from "./pages/BlogsPage";
import ReadBlog from "./pages/ReadBlog"
function App() {
  return (
    <BrowserRouter>
      <div>
        <Switch>
          <Route path="/" exact component={Home} />
          <Route path="/request-demo" exact component={Demo} />
          <Route path="/free-trial" exact component={Freetrail} />
          <Route path="/blogs" exact component={BlogsPage} />
          <Route path="/blogs/read" exact component={ReadBlog} />
        </Switch>
      </div>
    </BrowserRouter>
  );
}

export default App;
